import React, {Component, PropTypes} from 'react';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './email-element.style.js';

export class EmailElement extends Component {
  getValue() {
    const { response, defaultValue } = this.props;
    return response ? response : defaultValue ? defaultValue : "";
  }

  render() {
    const { isRequired, label, id, onChange, response, disabled, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);

    return (
      <div className={css.group + ' validated-section'}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          isRequired={isRequired}/>
        <input
          id={id}
          type="email"
          value={this.getValue()}
          onChange={e => onChange(e.target.value)}
          className={css.input + ' validated-input'}
          disabled={disabled}
          aria-required={isRequired}
          aria-invalid={hasErrors && showErrors}
          aria-describedby={errorIds} />
          {inlineErrors && inlineErrors.map(warn => (
            <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
          ))}
      </div>
    );
  }
}

EmailElement.defaultProps = {
  isRequired: false
};

EmailElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (EmailElement);



// WEBPACK FOOTER //
// src/common/form-elements/email-element-folder/email-element.js